// source: https://shopline.atlassian.net/wiki/spaces/EN/pages/2928050271/SHOP+Sentry#Shop-Page-%E7%B5%B1%E6%95%B4
export const PAGE_TYPE = {
  // checkout related
  plp: 'plp',
  pdp: 'pdp',
  cart: 'cart',
  checkout: 'checkout',
  confirm: 'confirm',
  fastCheckout: 'fastCheckout',
  expressCheckout: 'expressCheckout',
  onePageStoreCheckout: 'onePageStoreCheckout',
  promotions: 'promotions',
  // storefront related
  home: 'home',
  about: 'about',
  terms: 'terms',
  privacyPolicy: 'privacyPolicy',
  returnPolicy: 'returnPolicy',
  deliveryPolicy: 'deliveryPolicy',
  antiFraud: 'antiFraud',
  blog: 'blog',
  blogPost: 'blogPost',
  // customer related
  signIn: 'signIn',
  forgotPassword: 'forgotPassword',
  resetPassword: 'resetPassword',
  memberCenter: 'memberCenter',
  user: 'user',
  memberPoints: 'memberPoints',
  userCredits: 'userCredits',
  coupons: 'coupons',
  couponCenter: 'couponCenter',
  messages: 'messages',
  olp: 'olp',
  odp: 'odp',
  wishlist: 'wishlist',
};
